import { RootState } from "../../../../app/store/store";

export const selectUserOrders = (state: RootState) => state.userOrders;
